import React, {Component} from 'react'

import IpadNavigation from 'Navigation/IpadNavigation'
import Smartphones from 'Reports/views/TaxPaymentReport/TaxPaymentReportsView/containers/Smartphones'

export default class TaxPaymentReportsView extends Component {
  render () {
    return (
      <IpadNavigation {...this.props} onlyLeftSide setPreviousLink>
        <Smartphones {...this.props} />
      </IpadNavigation>
    )
  }
}
